// extracted by mini-css-extract-plugin
export var container = "_ks-0";
export var dotAnimation = "_ks-2";
export var dotsLoading = "_ks-1";